// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fwzODbDUicECYyNGrJPmCw\\=\\={width:8px;height:100%}.NcCDOisrbpNS3ekQFwHcXQ\\=\\={width:calc(100% - 8px)}", "",{"version":3,"sources":["webpack://./src/notifications/styles/NotificationPanel.scss"],"names":[],"mappings":"AAEA,4BACE,SAHe,CAIf,WAAA,CAGF,4BACE,sBAAA","sourcesContent":["$indicatorWidth: 8px;\n\n.notificationIndicator {\n  width: $indicatorWidth;\n  height: 100%;\n}\n\n.notificationBody {\n  width: calc(100% - #{$indicatorWidth});\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationIndicator": "fwzODbDUicECYyNGrJPmCw==",
	"notificationBody": "NcCDOisrbpNS3ekQFwHcXQ=="
};
export default ___CSS_LOADER_EXPORT___;
